// src/constants/fonts.js

const CHARWIDTHS = {
  A: 1.1,
  B: 1.1,
  C: 1.2,
  D: 1.2,
  E: 1.1,
  F: 1.0,
  G: 1.2,
  H: 1.2,
  I: 0.6,
  J: 1.0,
  K: 1.1,
  L: 1.0,
  M: 1.4,
  N: 1.2,
  O: 1.3,
  P: 1.0,
  Q: 1.3,
  R: 1.1,
  S: 1.1,
  T: 1.1,
  U: 1.1,
  V: 1.1,
  W: 1.5,
  X: 1.1,
  Y: 1.1,
  Z: 1.1,
  a: 0.9,
  b: 1.0,
  c: 0.9,
  d: 1.0,
  e: 1.0,
  f: 0.6,
  g: 1.0,
  h: 0.9,
  i: 0.4,
  j: 0.6,
  k: 0.9,
  l: 0.5,
  m: 1.4,
  n: 0.9,
  o: 1.0,
  p: 1.0,
  q: 1.0,
  r: 0.7,
  s: 0.9,
  t: 0.6,
  u: 1.0,
  v: 0.8,
  w: 1.3,
  x: 0.9,
  y: 0.9,
  z: 0.9,
  0: 1.1,
  1: 0.7,
  2: 1.0,
  3: 1.1,
  4: 1.1,
  5: 1.0,
  6: 1.1,
  7: 1.0,
  8: 1.1,
  9: 1.1,
  "&": 1.2,
  ",": 0.5,
  ".": 0.5,
  "-": 0.7,
};

const CHARSET = "A-Za-z0-9,.'&-$* ";

const SIZEMAP = [
  { code: "01", height: 1.0, name: "1 inch" },
  { code: "02", height: 2.0, name: "2 inch" },
  { code: "03", height: 3.0, name: "3 inch" },
  { code: "04", height: 4.0, name: "4 inch" },
  { code: "05", height: 5.0, name: "5 inch" },
  { code: "06", height: 6.0, name: "6 inch" },
  { code: "07", height: 7.0, name: "7 inch" },
  { code: "08", height: 8.0, name: "8 inch" },
  { code: "09", height: 9.0, name: "9 inch" },
  { code: "10", height: 10.0, name: "10 inch" },
  { code: "11", height: 11.0, name: "11 inch" },
  { code: "12", height: 12.0, name: "12 inch" },
];

export const FONTS = [
  {
    name: "Ubuntu",
    code: "Ubuntu",
    path: "/fonts/Ubuntu-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.773,
    sizes: SIZEMAP,
  },
  {
    name: "Abril Fatface",
    code: "Abril_Fatface",
    path: "/fonts/AbrilFatface-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.763,
    sizes: SIZEMAP,
  },
  {
    name: "Acme",
    code: "Acme",
    path: "/fonts/Acme-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.648,
    sizes: SIZEMAP,
  },
  {
    name: "Alba Matter",
    code: "Alba_Matter",
    path: "/fonts/albam_.ttf",
    format: "truetype",
    upcharge: 1.35,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.606,
    sizes: SIZEMAP,
  },
  {
    name: "Alfa Slab",
    code: "Alfa_Slab",
    path: "/fonts/AlfaSlabOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.794,
    sizes: SIZEMAP,
  },
  {
    name: "Americana",
    code: "Americana",
    path: "/fonts/GT-Americana_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.993,
    sizes: SIZEMAP,
  },
  {
    name: "Antique Olive",
    code: "Antique_Olive",
    path: "/fonts/GT-AntiqueOliveMedium.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.729,
    sizes: SIZEMAP,
  },
  {
    name: "Anton",
    code: "Anton",
    path: "/fonts/Anton-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.485,
    sizes: SIZEMAP,
  },
  {
    name: "Antonio",
    code: "Antonio",
    path: "/fonts/Antonio-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.441,
    sizes: SIZEMAP,
  },
  {
    name: "Architectural",
    code: "Architectural",
    path: "/fonts/GT-Architectural_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.762,
    sizes: SIZEMAP,
  },
  {
    name: "Archivo Narrow",
    code: "Archivo_Narrow",
    path: "/fonts/ArchivoNarrow-Medium.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.62,
    sizes: SIZEMAP,
  },
  {
    name: "Arial",
    code: "Arial",
    path: "/fonts/GT-Arial_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.723,
    sizes: SIZEMAP,
  },
  {
    name: "Arial Bold",
    code: "Arial_Bold",
    path: "/fonts/GT-Arial_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.755,
    sizes: SIZEMAP,
  },
  {
    name: "Audiowide",
    code: "Audiowide",
    path: "/fonts/Audiowide-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.904,
    sizes: SIZEMAP,
  },
  {
    name: "Avant Extra Bold",
    code: "Avant_Extra_Bold",
    path: "/fonts/GT-Avant_Extra_Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.763,
    sizes: SIZEMAP,
  },
  {
    name: "Avant Garde Medium",
    code: "Avant_Garde_Medium",
    path: "/fonts/GT-Avant_Garde_Medium_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.777,
    sizes: SIZEMAP,
  },
  {
    name: "Balthazer",
    code: "Balthazer",
    path: "/fonts/Balthazar-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.725,
    sizes: SIZEMAP,
  },
  {
    name: "Bauhaus",
    code: "Bauhaus",
    path: "/fonts/GT-Bauhaus.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.675,
    sizes: SIZEMAP,
  },
  {
    name: "Bangers",
    code: "Bangers",
    path: "/fonts/Bangers-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.514,
    sizes: SIZEMAP,
  },
  {
    name: "Barlow Condensed",
    code: "Barlow_Condensed",
    path: "/fonts/BarlowCondensed-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.544,
    sizes: SIZEMAP,
  },
  {
    name: "Bebas",
    code: "Bebas",
    path: "/fonts/BebasNeue-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.537,
    sizes: SIZEMAP,
  },
  {
    name: "Benguiat",
    code: "Benguiat",
    path: "/fonts/GT-Benguiat_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.752,
    sizes: SIZEMAP,
  },
  {
    name: "Berkshire Swash",
    code: "Berkshire_Swash",
    path: "/fonts/BerkshireSwash-Regular.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.699,
    sizes: SIZEMAP,
  },
  {
    name: "Bodoni Italic",
    code: "Bodoni_Italic",
    path: "/fonts/LibreBodoni-SemiBoldItalic.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.962,
    sizes: SIZEMAP,
  },
  {
    name: "Brush Script",
    code: "Brush_Script",
    path: "/fonts/GT-Brush_Script_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.66,
    sizes: SIZEMAP,
  },
  {
    name: "Caprasimo",
    code: "Caprasimo",
    path: "/fonts/Caprasimo-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.873,
    sizes: SIZEMAP,
  },
  {
    name: "Casual Italic",
    code: "Casual_Italic",
    path: "/fonts/GT-Casual_Italic_Script.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.584,
    sizes: SIZEMAP,
  },
  {
    name: "Century Bold Condensed",
    code: "Century_Bold_Condensed",
    path: "/fonts/GT-Century_Bold_Cond.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.539,
    sizes: SIZEMAP,
  },
  {
    name: "Century Schoolbook",
    code: "Century_Schoolbook",
    path: "/fonts/Domine-SemiBold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.966,
    sizes: SIZEMAP,
  },
  {
    name: "Clarendon Bold",
    code: "Clarendon_Bold",
    path: "/fonts/GT-Clarendon_Fortune_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.852,
    sizes: SIZEMAP,
  },
  {
    name: "Clarion",
    code: "Clarion",
    path: "/fonts/GT-Clarion.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 1.179,
    sizes: SIZEMAP,
  },
  {
    name: "Clearview Light",
    code: "Clearview_Light",
    path: "/fonts/GT-ClearviewOneLight.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.692,
    sizes: SIZEMAP,
  },
  {
    name: "Clearview Bold",
    code: "Clearview_Bold",
    path: "/fonts/GT-ClearviewOneBold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.828,
    sizes: SIZEMAP,
  },
  {
    name: "Consort",
    code: "Consort",
    path: "/fonts/GT-Consort.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.863,
    sizes: SIZEMAP,
  },
  {
    name: "Cookie",
    code: "Cookie",
    path: "/fonts/Cookie-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.606,
    sizes: SIZEMAP,
  },
  {
    name: "Country Gothic",
    code: "Country_Gothic",
    path: "/fonts/GT-Country_Gothic.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.716,
    sizes: SIZEMAP,
  },
  {
    name: "Creepster",
    code: "Creepster",
    path: "/fonts/Creepster-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.528,
    sizes: SIZEMAP,
  },
  {
    name: "Crushed",
    code: "Crushed",
    path: "/fonts/Creepster-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.546,
    sizes: SIZEMAP,
  },
  {
    name: "Exo Bold",
    code: "Exo_Bold",
    path: "/fonts/Exo2-Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.757,
    sizes: SIZEMAP,
  },
  {
    name: "Fjalla",
    code: "Fjalla",
    path: "/fonts/FjallaOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.498,
    sizes: SIZEMAP,
  },
  {
    name: "Fontdiner Swanky",
    code: "Fontdiner_Swanky",
    path: "/fonts/FontdinerSwanky-Regular.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.914,
    sizes: SIZEMAP,
  },
  {
    name: "Friz Quadrata",
    code: "Friz_Quadrata",
    path: "/fonts/GT-Friz_Quadrata_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.743,
    sizes: SIZEMAP,
  },
  {
    name: "Futura",
    code: "Futura",
    path: "/fonts/Jost-Medium.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.752,
    sizes: SIZEMAP,
  },
  {
    name: "Futura Bold",
    code: "Futura_Bold",
    path: "/fonts/Jost-Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.875,
    sizes: SIZEMAP,
  },
  {
    name: "Futura Condensed",
    code: "Futura_Condensed",
    path: "/fonts/GT-Futura_Condensed_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.545,
    sizes: SIZEMAP,
  },
  {
    name: "Futura Demibold",
    code: "Futura_Demibold",
    path: "/fonts/Jost-SemiBold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.704,
    sizes: SIZEMAP,
  },
  {
    name: "Gemco",
    code: "Gemco",
    path: "/fonts/GT-Gemco.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.705,
    sizes: SIZEMAP,
  },
  {
    name: "Grand Hotel",
    code: "Grand_Hotel",
    path: "/fonts/GrandHotel-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.518,
    sizes: SIZEMAP,
  },
  {
    name: "Helvetica",
    code: "Helvetica",
    path: "/fonts/GT-Helvetica_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.815,
    sizes: SIZEMAP,
  },
  {
    name: "Helvetica Bold",
    code: "Helvetica_Bold",
    path: "/fonts/GT-Helvetica_Bold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: "^[A-Za-z0-9,.'&\\-$*s]*$",
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.96,
    sizes: SIZEMAP,
  },
  {
    name: "Helvetica Medium Condensed",
    code: "Helvetica_Medium_Condensed",
    path: "/fonts/GT-Helvetica_Medium_Cond_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.674,
    sizes: SIZEMAP,
  },
  {
    name: "Herman Italic",
    code: "Herman_Italic",
    path: "/fonts/GT-Herman_Italic.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.817,
    sizes: SIZEMAP,
  },
  {
    name: "Holtwood One",
    code: "Holtwood_One",
    path: "/fonts/HoltwoodOneSC-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.992,
    sizes: SIZEMAP,
  },
  {
    name: "Impact",
    code: "Impact",
    path: "/fonts/impact.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.551,
    sizes: SIZEMAP,
  },
  {
    name: "Italicized Script",
    code: "Italicized_Script",
    path: "/fonts/GT-Italicized_Script.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.643,
    sizes: SIZEMAP,
  },
  {
    name: "Kavoon",
    code: "Kavoon",
    path: "/fonts/Kavoon-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.693,
    sizes: SIZEMAP,
  },
  {
    name: "Lato Bold",
    code: "Lato_Bold",
    path: "/fonts/Lato-Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.728,
    sizes: SIZEMAP,
  },
  {
    name: "Leckerli One",
    code: "Leckerli_One",
    path: "/fonts/LeckerliOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.685,
    sizes: SIZEMAP,
  },
  {
    name: "Lily Script One",
    code: "Lily_Script_One",
    path: "/fonts/LilyScriptOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.649,
    sizes: SIZEMAP,
  },
  {
    name: "Limelight",
    code: "Limelight",
    path: "/fonts/Limelight-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.822,
    sizes: SIZEMAP,
  },
  {
    name: "Lobster",
    code: "Lobster",
    path: "/fonts/Lobster-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.613,
    sizes: SIZEMAP,
  },
  {
    name: "Luckiest Guy",
    code: "Luckiest_Guy",
    path: "/fonts/LuckiestGuy-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.732,
    sizes: SIZEMAP,
  },
  {
    name: "Magneto",
    code: "Magneto",
    path: "/fonts/magnetob.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.887,
    sizes: SIZEMAP,
  },
  {
    name: "Mystery Quest",
    code: "Mystery_Quest",
    path: "/fonts/MysteryQuest-Regular.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.594,
    sizes: SIZEMAP,
  },
  {
    name: "Nerko One",
    code: "Nerko_One",
    path: "/fonts/NerkoOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.69,
    sizes: SIZEMAP,
  },
  {
    name: "Norwester",
    code: "Norwester",
    path: "/fonts/norwester.otf",
    format: "otf",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.566,
    sizes: SIZEMAP,
  },
  {
    name: "Nova Square",
    code: "Nova_Square",
    path: "/fonts/NovaSquare-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.682,
    sizes: SIZEMAP,
  },
  {
    name: "Oleo Script",
    code: "Oleo_Script",
    path: "/fonts/OleoScript-Bold.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.627,
    sizes: SIZEMAP,
  },
  {
    name: "Optima",
    code: "Optima",
    path: "/fonts/GT-Optima_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.686,
    sizes: SIZEMAP,
  },
  {
    name: "Optima Semibold",
    code: "Optima_Semibold",
    path: "/fonts/GT-Optima_Semibold_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.73,
    sizes: SIZEMAP,
  },
  {
    name: "Oswald",
    code: "Oswald",
    path: "/fonts/Oswald-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.545,
    sizes: SIZEMAP,
  },
  {
    name: "Pacifico",
    code: "Pacifico",
    path: "/fonts/Pacifico-Regular.ttf",
    format: "truetype",
    upcharge: 1.2,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.643,
    sizes: SIZEMAP,
  },
  {
    name: "Palatino",
    code: "Palatino",
    path: "/fonts/Merriweather-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.746,
    sizes: SIZEMAP,
  },
  {
    name: "Palatino Semibold",
    code: "Palatino_Semibold",
    path: "/fonts/Merriweather-Bold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.768,
    sizes: SIZEMAP,
  },
  {
    name: "Peralta",
    code: "Peralta",
    path: "/fonts/Peralta-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.907,
    sizes: SIZEMAP,
  },
  {
    name: "Perfaire",
    code: "Perfaire",
    path: "/fonts/GT-Perfaire.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.802,
    sizes: SIZEMAP,
  },
  {
    name: "Permanent Marker",
    code: "Permanent_Marker",
    path: "/fonts/PermanentMarker-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.721,
    sizes: SIZEMAP,
  },
  {
    name: "Ranchers",
    code: "Ranchers",
    path: "/fonts/Ranchers-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.54,
    sizes: SIZEMAP,
  },
  {
    name: "Roboto Slab",
    code: "Roboto_Slab",
    path: "/fonts/RobotoSlab-SemiBold.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.755,
    sizes: SIZEMAP,
  },
  {
    name: "Rubik",
    code: "Rubik",
    path: "/fonts/Rubik-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.743,
    sizes: SIZEMAP,
  },
  {
    name: "Saira Stencil",
    code: "Saira_Stencil",
    path: "/fonts/SairaStencilOne-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.775,
    sizes: SIZEMAP,
  },
  {
    name: "Salsa",
    code: "Salsa",
    path: "/fonts/Salsa-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.689,
    sizes: SIZEMAP,
  },
  {
    name: "Sarina",
    code: "Sarina",
    path: "/fonts/Sarina-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 1.001,
    sizes: SIZEMAP,
  },
  {
    name: "Satisfy",
    code: "Satisfy",
    path: "/fonts/Satisfy-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.466,
    sizes: SIZEMAP,
  },
  {
    name: "Shojumaru",
    code: "Shojumaru",
    path: "/fonts/Shojumaru-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.959,
    sizes: SIZEMAP,
  },
  {
    name: "Short Stack",
    code: "Short_Stack",
    path: "/fonts/ShortStack-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.746,
    sizes: SIZEMAP,
  },
  {
    name: "Sofia",
    code: "Sofia",
    path: "/fonts/Sofia-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.721,
    sizes: SIZEMAP,
  },
  {
    name: "Standard Block",
    code: "Standard_Block",
    path: "/fonts/GT-Standard_Block_v2.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.644,
    sizes: SIZEMAP,
  },
  {
    name: "Standard Block Condensed",
    code: "Standard_Block_Condensed",
    path: "/fonts/GT-Standard_Block_Cond.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.515,
    sizes: SIZEMAP,
  },
  {
    name: "Times Roman",
    code: "Times_Roman",
    path: "/fonts/GT-Times_Roman.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.763,
    sizes: SIZEMAP,
  },
  {
    name: "Titillium Web",
    code: "Titillium_Web",
    path: "/fonts/TitilliumWeb-Regular.ttf",
    format: "truetype",
    upcharge: 1.0,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 0.713,
    sizes: SIZEMAP,
  },
  {
    name: "Custom Font File",
    code: "Custom_Font_File",
    path: "/fonts/GT-Arial_v2.ttf",
    format: "truetype",
    upcharge: 1.5,
    charset: CHARSET,
    charWidths: CHARWIDTHS,
    fontAdjustment: 1.0,
    sizes: SIZEMAP,
  },
];
